import { BedroomsNewContainer } from '../../containers/advancedFilters/BedroomsNewContainer';
import { IFilter } from '../../types/advancedFilters';

export const bedroomsNew: IFilter = {
  component: BedroomsNewContainer,
};
